import { z } from 'zod';

export enum ActivityType {
  USER_FILE = 'USER_FILE',
}

export const ActivityEnumSchema = z.nativeEnum(ActivityType);

// Related to ActivityType.USER_FILE
export enum ActivityFileAction {
  // TODO: replace the values by the FEAPI equivalent (for easy mapping)
  CREATE = 'Create',
  UPDATE = 'Update',
  DELETE = 'Delete',
}

export const ActivityFileActionSchema = z.nativeEnum(ActivityFileAction);
